<next-form
  [page]="page"
  [pages]="pages"
  [storeId]="formValuesStoreId"
  [validationStrategy]="validationStrategy"
  (isValidChanged)="handleIsValidChanged($event)"
  #formComponent
></next-form>

<next-form-actions
  [actions]="page.navigation"
  [disabled]="disabledActions"
  (action)="handleAction($event)"
></next-form-actions>
